
import { generatePDFReceipt, ReceiptData } from './pdfGenerator';
import { supabase } from '@/integrations/supabase/client';

interface Customer {
  id: string;
  name: string | null;
  email: string | null;
  phone: string | null;
  address: string | null;
  postcode: string | null;
  payment_links?: {
    amount: number;
    currency: string;
    description: string;
  };
  created_at: string;
}

export const generateCustomerReceipt = async (
  customer: Customer,
  businessProfile: any
): Promise<string> => {
  console.log('Generating receipt for customer:', customer.name);
  
  const receiptData: ReceiptData = {
    receiptNumber: `REC-${customer.id.substring(0, 8).toUpperCase()}`,
    date: new Date(customer.created_at).toLocaleDateString('en-GB'),
    amount: customer.payment_links?.amount || 0,
    currency: customer.payment_links?.currency || 'GBP',
    description: customer.payment_links?.description || 'Payment',
    customerName: customer.name || undefined,
    customerEmail: customer.email || undefined,
    customerPhone: customer.phone || undefined,
    customerAddress: (customer.address || customer.postcode) ? {
      street: customer.address || undefined,
      postcode: customer.postcode || undefined
    } : undefined,
    businessProfile,
    bankDetails: businessProfile?.bank_details ? {
      accountName: businessProfile.bank_details.account_name,
      accountNumber: businessProfile.bank_details.account_number,
      sortCode: businessProfile.bank_details.sort_code,
      bankName: businessProfile.bank_details.bank_name,
      iban: businessProfile.bank_details.iban,
      swift: businessProfile.bank_details.swift
    } : undefined,
    includeAddress: !!(customer.address || customer.postcode)
  };
  
  return await generatePDFReceipt(receiptData);
};

export const downloadPDFFromDataURI = (dataURI: string, filename: string) => {
  const link = document.createElement('a');
  link.href = dataURI;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
